export const environment = {
    api_url: "https://saas-api.mylavni.com",
    app_url: "https://saas.mylavni.com",
    file_access_url: "/api/public/file",
    socket_uri: "https://saas-api.mylavni.com", // Live : https://api.lavnihealth.com,
    vimeo_access_token: "a3de9a00744c88a947217c84afcb4707",
    vimeo_base_url: "https://api.vimeo.com",
    stripe_publishable_key: "pk_test_51LHfN6Iit1GJhbbNPU9FfOaT73Kz3oTjqMfRD8Me39AcaPC5SeNQVLcgq2RW1F0mPr2qyBuizrdK5m4YIwwvbRga006HfbrnrB",
    google_recaptcha_site_key: "6LcZN-UgAAAAAIDu2QPY1aSSRE6-HEmrRE9fQddZ",
    google_recaptcha_secret_key: "6LcZN-UgAAAAAKt8UKnsuTgOB2UNW5k3_alFF-XP",
    google_analytics_tracking_code: "G-1ZGCB2RLYG",
    facebook_pixel_code: "642813639532772",
    NPI2: "1215673256",
    product1Pricing: 299,
    recorded_files_access_url:"/api/public/recorded_files",
    google_calendar_client_id: "887304794137-kq5kge9fd52d58t0ukebv7n6sk0t4o9a.apps.googleusercontent.com",
    google_api_key: "AIzaSyDUjnF_o-PlTq26MVjC3cECLk_hab9mo0c",
    google_calendar_scope: "https://www.googleapis.com/auth/calendar",
    google_calendar_discovery_docs: [
        "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"
    ],
    chat_encryption_key: "obvwoqcbv21801f19d0zibcoavwpnq",
    google_client_Id:"777497092645-555kt06i5r6af4nmk26c8qfhaadi2skk.apps.googleusercontent.com",
    facebook_app_id:"396491945838403",
    group_chat_encryption_key: "obvwoqcbv21801f19d0zibcoavwpnq",
    admin_client_chat_encryption_key: "obvwoqcbv21801f19d0zibcoavwpnq"
};
